import { useState } from "react";
import { useNavigate } from "react-router";
// @mui
import { Button, Stack, Typography } from "@mui/material";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import DownloadIcon from "@mui/icons-material/Download";
// handlers
import SharedHandler, {
  addGotoNavigation,
  addCaptchaToLocalStorage,
} from "src/components/UI/Shared/handler";
import user from "src/components/UI/Shared/user";
import { RESPONSE_STATUS, MAPPING_SERVICE_NAME } from "src/config/service";
import { handleRequest } from "src/components/UI/Profile/handler";
// assets
import styles from "src/components/UI/Profile/assets/scss/Profile.module.scss";
// redux
import { useDispatch } from "react-redux";
import { appActions } from "src/store/store";

type Props = {
  balance: number;
  optionalParam: string;
};
type HistoryRecord = {
  amount: string;
  credits: string;
  date: string;
  service: string;
  type: string;
};
const CreditsDisplay = ({ balance, optionalParam }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [disableDownloadBtn, setDisableDownloadBtn] = useState(false);
  const apiURL = process.env.REACT_APP_API_URL || "";

  const createHistoryFile = async (records: HistoryRecord[]) => {
    const lines = ["Date-Time,Amount,Credits,Service Name,Type"];
    records.forEach((record) => {
      lines.push(
        `${record.date},${record.amount},${record.credits},${record.service},${record.type}`
      );
    });
    const content = lines.join("\n");
    setDisableDownloadBtn(false);
    const fileBlob = SharedHandler.createFileBlobHandler(
      content,
      "text/csv;charset=utf-8"
    );
    await SharedHandler.saveFile(fileBlob, "credit-history.csv");
  };
  const behaviour = async (returned: any) => {
    if (returned.flag === "TRACKING") {
      if (returned.message[0] === RESPONSE_STATUS.BLOCKED) {
        await dispatch(
          appActions.setNotification({
            severity: "error",
            message:
              "Service cap reached today! Take a breather and come back for more fun tomorrow!",
            open: true,
          })
        );
      } else if (returned.message[1]) {
        await addCaptchaToLocalStorage(returned.message[1]);
        dispatch(
          appActions.setTrackingData({
            captcha: returned.message[1],
            serviceStatus: returned.message[0],
          })
        );
      } else {
        dispatch(
          appActions.setTrackingData({ serviceStatus: returned.message[0] })
        );
      }
    } else if (returned.flag === "SUCCESS") {
      createHistoryFile(returned.message[1]);
      dispatch(
        appActions.setNotification({
          open: true,
          message: returned.message[0],
          severity: "success",
        })
      );
    } else if (returned.flag === "ERROR") {
      dispatch(
        appActions.setNotification({
          open: true,
          message:
            returned.message && returned.message !== ""
              ? returned.message
              : "Error occured.",
          severity: "error",
        })
      );
    }
  };
  const handleDownloadHistory = async () => {
    addGotoNavigation("17");
    setDisableDownloadBtn(true);
    const email = user.parseUserEmail();

    const endpointUrl = "credit/getCreditsHistory/";
    const timestamp = new Date().toISOString();
    const signature = SharedHandler.signRequest(
      "/" + endpointUrl,
      "POST",
      timestamp
    );

    const formData = new FormData();
    formData.append("user_email", email);

    const requestSent = await handleRequest(
      apiURL ? apiURL : "",
      endpointUrl,
      formData,
      signature,
      timestamp,
      optionalParam
    );
    console.log(requestSent);

    await behaviour(requestSent);
  };

  return (
    <Stack spacing={0.25} alignItems={"flex-start"} sx={{ p: 0.75 }}>
      <div className={styles.detailsHeading}>
        <Typography className={styles.detailsHeader} variant="h5">
          Credit
        </Typography>
      </div>
      <div className={styles["credits-display"]}>
        <div
          style={{
            width: "60%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            className={`${styles.detailsInfoHead} ${styles["balance-head"]}`}
            variant="subtitle2"
          >
            Current balance:
          </Typography>
          <Typography className={styles.detailsInfo} variant="subtitle2">
            {` ${balance}`}
          </Typography>
          <Button
            className={styles["credits-btn"]}
            onClick={() => {
              navigate("../identity/payment");
            }}
            endIcon={<CreditScoreIcon />}
          >
            Purchase credit
          </Button>
        </div>
        <div className={styles["download-div"]}>
          <Button
            className={styles["donwload-btn"]}
            onClick={handleDownloadHistory}
            disabled={disableDownloadBtn}
            endIcon={<DownloadIcon />}
          />
          <span className={styles["download-label"]}>Credit History</span>
        </div>
      </div>
    </Stack>
  );
};
export default CreditsDisplay;
